export default __webpack_public_path__ + "static/media/oracle.e36744c3.svg";